import { defaultState } from '../../reducers/discussions';
import { ERequestStatus } from '../../types/requestStatus';
import { IDiscussion, TDiscussionsState } from '../../types/discussions';
import { EType } from '../../repositories/journal/entities/journal/FullListAttributesV2Schema';

export const mkDiscussions = (data?: IDiscussion[]): IDiscussion[] => {
  return [
    {
      post: {
        id: 330036,
        attributes: {
          title:
            'О возможности переносить обязательство о наделении долями детей после использования маткапитала на другое жилье',
          slug: 'ustanovku-umnyh-schetchikov-hotjat-vkljuchit-v-tarify-zhkh',
          type: EType.News,
          commentsCount: 10,
          likesCount: 200,
        },
        type: 'news',
      },
      comment: {
        id: 330037,
        text: 'Добрый день! Благодарю за информацию и конечно за то, что читаете мои "насыщенные" сочинения. Законопроект включен в календарь рассмотрения Государственной Думой на 29 мая 2024 года.',
      },
      users: [
        {
          id: 1,
          avatar: 'https://www.cian.ru/api/get-avatar/?i=17068&amp;t=2&amp;p=2',
        },
        {
          id: 2,
          avatar: 'https://www.cian.ru/avatar.axd?i=120157595&amp;t=1&amp;p=2',
        },
        {
          id: 3,
          avatar: 'https://www.cian.ru/avatar.axd?i=13423037&amp;t=1&amp;p=2',
        },
      ],
    },
    {
      post: {
        id: 330038,
        attributes: {
          title: 'Раздел имущества и уплата налога',
          slug: 'ustanovku-umnyh-schetchikov-hotjat-vkljuchit-v-tarify-zhkh',
          type: EType.News,
          commentsCount: 1,
          likesCount: 30,
        },
        type: 'news',
      },
      comment: {
        id: 330039,
        text: 'Здравствуйте. Вопрос сложный а информации крайне мало. Будет ли налог, зависит от того, кто и когда будет подавать квартиру. Если жена - значит нужно определять минимальные сроки владения - 3 или 5 лет (единственное/не единственное жилье) и момент начала срока (новостройка или вторичка - с даты оплаты/с даты регистрации права). Если будет раздел, то нужно понимать, в какой момент и на каком основании - до развода или уже после, по соглашению или по суду.',
      },
      users: [
        {
          id: 1,
          avatar: 'https://www.cian.ru/api/get-avatar/?i=17068&amp;t=2&amp;p=2',
        },
        {
          id: 2,
          avatar: 'https://www.cian.ru/avatar.axd?i=120157595&amp;t=1&amp;p=2',
        },
        {
          id: 3,
          avatar: 'https://www.cian.ru/avatar.axd?i=13423037&amp;t=1&amp;p=2',
        },
      ],
    },
    {
      post: {
        id: 330040,
        attributes: {
          title: 'Покупка залогового жилья в ипотеку стороннего банка',
          slug: 'ustanovku-umnyh-schetchikov-hotjat-vkljuchit-v-tarify-zhkh',
          type: EType.News,
          commentsCount: 1,
          likesCount: 30,
        },
        type: 'news',
      },
      comment: {
        id: 330041,
        text: 'Александр, речь идёт о покупке в ипотеку залоговых объектов стороннего банка. Аккредитив с трансферацией в Сбере действительно классная штука, про которую я ранее писала, но он не подходит под тему блога.',
      },
      users: [
        {
          id: 1,
          avatar: 'https://www.cian.ru/api/get-avatar/?i=17068&amp;t=2&amp;p=2',
        },
        {
          id: 2,
          avatar: 'https://www.cian.ru/avatar.axd?i=120157595&amp;t=1&amp;p=2',
        },
        {
          id: 3,
          avatar: 'https://www.cian.ru/avatar.axd?i=13423037&amp;t=1&amp;p=2',
        },
      ],
    },
    {
      post: {
        id: 330042,
        attributes: {
          title: 'Банкиры ждут взрывного роста спроса на льготную ипотеку',
          slug: 'ustanovku-umnyh-schetchikov-hotjat-vkljuchit-v-tarify-zhkh',
          type: EType.News,
          commentsCount: 1,
          likesCount: 30,
        },
        type: 'news',
      },
      comment: {
        id: 330043,
        text: 'согласен законопроект очень нужный',
      },
      users: [
        {
          id: 1,
          avatar: 'https://www.cian.ru/api/get-avatar/?i=17068&amp;t=2&amp;p=2',
        },
        {
          id: 2,
          avatar: 'https://www.cian.ru/avatar.axd?i=120157595&amp;t=1&amp;p=2',
        },
        {
          id: 3,
          avatar: 'https://www.cian.ru/avatar.axd?i=13423037&amp;t=1&amp;p=2',
        },
      ],
    },
    ...(data || []),
  ];
};

export const mkDiscussionsState = (data?: Partial<TDiscussionsState>): TDiscussionsState => {
  return {
    ...defaultState,
    status: ERequestStatus.Succeed,
    items: mkDiscussions(),
    ...data,
  };
};
